import React from "react";
import PropTypes from 'prop-types';
import $ from 'jquery';
import uuid from "uuid";

import * as Misc from "../../misc";
import Middleware from "../../middleware";
import ActionTypes from "../../actionTypes";
import ProjectScope from "../projectScope/projectScope";
import MessageBox from "../common/messageBox/messageBox";
import OnScreenKeyboard from "../OnScreenKeyboard/keyboard";
import StonesStore from "../../stores/stonesStore";
import Config from "../../config";
import Analytics from './../../analytics';

import IntlTelInput from 'react-intl-tel-input';
import 'file-loader?name=libphonenumber.js!../../../node_modules/react-intl-tel-input/dist/libphonenumber.js';

const assign = require('object.assign/polyfill')();

export default class CustomerView extends React.Component {
  static propTypes = {
    userAuthenticated: PropTypes.func.isRequired
  };

  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    const href = window.location.href;
    const isDemo = /quotesflooring.com/i.test(href)
      || /gfd.us/.test(href)
      || ProjectScope.isDemoProfile()
      || /:9007/i.test(href)
      || Config.isShowroomMode();
    const userInfo = StonesStore.userInfo;

    this.state = {
      view: this.props.view,
      email: (isDemo ? 'demo@demo.com' : (userInfo ? decodeURI(userInfo.email) : '')),
      password: isDemo ? '__demopasssword__' : '',
      fullName: (isDemo ? 'Demo User' : (userInfo ? decodeURI(userInfo.fullName) : '')),
      phoneNumber: (isDemo ? '+1 8883335566' : (userInfo ? decodeURI(userInfo.phone) : '+1 ')),
      zip: (isDemo ? '85800' : (userInfo ? decodeURI(userInfo.zip) : '')),
      disabled: false,
      isBusy: false,
      isMessageBoxVisible: false,
      errorMessage: '',
      isMessageBoxError: true,
      emailId: 'ui-login-email',
      regEmailId: 'ui-reg-email',
      passwordId: 'ui-passsword',
      fullNameId: 'ui-fullname',
      phoneNumberId: 'ui-phone-number',
      zipId: 'ui-zip',
      salesPersonFullNameId: 'ui-sales-person-fullname',
      salesPersonEmailId: 'ui-sales-person-email',
      salesPersonDetailsVisible: false,
      salesPersonEmail: '',
      salesPersonFullName: '',
      salesPersonDetailsLoginVisible: false,
      country: {
        areaCodes: null,
        dialCode: "1",
        iso2: "us",
        name: "United States",
        priority: 0
      }
    };
  }

  handleChangeNumber = (a, b, c, phoneNumber) => {
    phoneNumber = phoneNumber.replace(/[^0-9\+\-\(\)\s\.]/gi, "");
    let prefix = `+${this.state.country.dialCode}`;
    if(!_.startsWith(phoneNumber, prefix + ' ') || _.trim(phoneNumber).length == 0) {
      let hasPrefix = phoneNumber.substring(0, prefix.length) == prefix;
      if(hasPrefix) phoneNumber = _.trim(phoneNumber.substring(prefix.length));
      phoneNumber = `${prefix} ${phoneNumber}`;
    }
    this.setState({phoneNumber});
  }

  handleChangeFlag = (currentNumber, selectedCountryData) => {
    var matches = currentNumber.match(/(\+\d{1,4}\s)/gi);
    if(matches && matches.length > 1) {
      currentNumber = currentNumber.replace(/\+\d{1,4}\s/gi, '');
      currentNumber = `${matches[1]}${currentNumber}`;
    } else {
      currentNumber = `+${selectedCountryData.dialCode} ${currentNumber}`;
    }
    this.setState({country: selectedCountryData, phoneNumber: currentNumber}); 
  }

  componentDidMount() {
    $(document).on(ActionTypes.USER_LOGIN_ANSWER, this.handleUserLoginAnswer);
    $(document).on(ActionTypes.USER_REGISTER_ANSWER, this.handleUserRegisterAnswer);
    $(document).on(ActionTypes.RESET_PASSWORD_ANSWER, this.handleResetPasswordAnswer);
  }

  componentWillUnmount() {
    $(document).off(ActionTypes.USER_LOGIN_ANSWER, this.handleUserLoginAnswer);
    $(document).off(ActionTypes.USER_REGISTER_ANSWER, this.handleUserRegisterAnswer);
    $(document).off(ActionTypes.RESET_PASSWORD_ANSWER, this.handleResetPasswordAnswer);
  }

  handleUserLoginAnswer = (e, data) => {
    this.setState({isBusy: false});
    if (data.data.error) {
      Analytics.sendEvent('user-login-response', 'failed');
      this.setState({isMessageBoxVisible: true, errorMessage: data.data.error});
      return;
    }

    $('.customer-info-popup__lock-circle').addClass('customer-info-popup__lock-circle--spreading');
    $('.customer-info-popup__lock-border').addClass('customer-info-popup__lock-border--smallspreading');

    Analytics.sendEvent('user-login-response', 'success');
    const userInfo = {};
    const {values} = data.data;

    if (data.data.antiForgeryToken) {
      $('input[name=__RequestVerificationToken]').val(data.data.antiForgeryToken);
    }

    if (values) { // online version
      assign(userInfo, {email: this.state.email}, values);
      userInfo.zip = values.postal;
      userInfo.phone = values.phone;
      userInfo.firstName = values.firstName + ' ' + values.lastName;
      userInfo.password = data.password;
      userInfo.encodedUserId = data.data.encodedUserId;
      userInfo.isPhoneNumberValidated = data.data.isPhoneNumberValidated;
      Analytics.setUserId(userInfo.encodedUserId);
    } else {
      userInfo.email = data.data.email;
      userInfo.password = data.data.password;
    }

    ProjectScope.setUserInfo(userInfo);

    ProjectScope.isNewUser = false;
    ProjectScope.salesPerson.name = this.state.salesPersonFullName;
    ProjectScope.salesPerson.email = this.state.salesPersonEmail;

    setTimeout(() => {
      this.props.userAuthenticated();
    }, 300);

    //Middleware.saveQuote(false);
  };

  handleUserRegisterAnswer = (e, data) => {
    this.setState({isBusy: false});
    if (data.data.error) {
      Analytics.sendEvent('user-registration-answer', 'failed');
      this.setState({isMessageBoxVisible: true, errorMessage: data.data.error});
      return;
    }

    $('.customer-info-popup__lock-circle').addClass('customer-info-popup__lock-circle--spreading');
    $('.customer-info-popup__lock-border').addClass('customer-info-popup__lock-border--smallspreading');

    Analytics.sendEvent('user-registration-answer', 'success');
    const userInfo = {};
    userInfo.email = this.state.email;
    userInfo.firstName = this.state.fullName;
    userInfo.phone = this.state.phoneNumber;
    userInfo.zip = this.state.zip;
    userInfo.encodedUserId = data.data.encodedUserId;

    ProjectScope.isNewUser = true;
    ProjectScope.setUserInfo(userInfo);
    Analytics.setMixPanelPerson(userInfo.email, userInfo.firstName, userInfo.phone);

    setTimeout(() => {
      this.props.userAuthenticated(true);
    }, 300);
  };

  handleResetPasswordAnswer = (e, data) => {
    this.setState({isBusy: false});
    const error = data.error || data.data.error;
    if (error) {
      Analytics.sendEvent('reset-password-answer', 'failed');
      this.setState({isMessageBoxVisible: true, errorMessage: error});
      return;
    }
    Analytics.sendEvent('reset-password-answer', 'success');

    this.setState({isMessageBoxVisible: true,
      isMessageBoxError: false,
      errorMessage: 'Password reset link has been sent to the email on file. Please open the email and click password reset link, then proceed back to Quoting Tool'});

    // this.context.router.replace('/scope');
  };

  setStateField = (field, e) => {
    this.setState({[field]: typeof e === 'string' ? e : e.target.value});
  };

  handleUserLoginClick = (e) => {
    Analytics.sendClickEvent('user-login');
    Misc.ignoreDefault(e);
    this.hideOverlayVideo(e);
    if (this.state.isBusy) {
      return;
    }

    const errors = [];
    if (!Misc.isEmail(this.state.email)) {
      errors.push('Email in correct format is required.');
    }
    if ((this.state.password || '').length < 2) {
      errors.push('Password must be at least 2 characters.');
    }

    if (errors.length) {
      this.setState({
        isMessageBoxVisible: true,
        errorMessage: errors.join('<br />')
      });
      return;
    }
    Middleware.userLogin(this.state.email, this.state.password);

    this.setState({isBusy: true});
  };

  /**
   * Called when on Login screen, user clicks [Sign Up] instead of [Login]
   * @param e
   */
  handleUserSignUpAttemptClick = (e) => {
    Analytics.sendClickEvent('user-register');
    Misc.ignoreDefault(e);
    this.hideOverlayVideo(e);
    if (this.state.isBusy) {
      return;
    }

    this.setState({view: 'register'});
  };

  handleUserBackRegisterClick = (e) => {
    Analytics.sendClickEvent('user-register-change-to-login');
    Misc.ignoreDefault(e);
    this.hideOverlayVideo(e);

    if (this.state.isBusy) {
      return;
    }

    this.setState({view: 'login'});
  };

  handleUserRegisterClick = (e) => {
    Analytics.sendClickEvent('user-register-show');
    Misc.ignoreDefault(e);
    this.hideOverlayVideo(e);
    if (this.state.isBusy) {
      return;
    }

    const errors = [];
    if ((this.state.fullName || '').length < 2 || this.state.fullName.length > 50) {
      errors.push('Full name is required.');
    }
    if (!Misc.isEmail(this.state.email)) {
      errors.push('Email is required.');
    }
    if (!Misc.isPhoneNumber(this.state.phoneNumber)) {
      errors.push('Phone number is required.');
    }
    if (!Misc.isZip(this.state.zip)) {
      errors.push('Postal code is required.');
    }

    if (errors.length) {
      this.setState({isMessageBoxVisible: true, errorMessage: errors.join('<br />')});
      return;
    }
    
    let userInfo = ProjectScope.userInfo() || {};
    userInfo.fullName = this.state.fullName;
    userInfo.email = this.state.email;
    userInfo.phone = this.state.phoneNumber;
    userInfo.zip = this.state.zip;
    ProjectScope.setUserInfo(userInfo);

    Middleware.userRegister(this.state.fullName, this.state.email, this.state.phoneNumber,
      this.state.zip, this.state.salesPersonFullName, this.state.salesPersonEmail);
    this.setState({isBusy: true});
  };

  handleForgotPasswordClick = (e) => {
    Analytics.sendClickEvent('password-forgot-button');
    Misc.ignoreDefault(e);
    this.hideOverlayVideo(e);
    this.setState({view: 'reset-password'});
  };

  handlePasswordResetButtonClick = (e) => {
    Analytics.sendClickEvent('password-reset-button');
    Misc.ignoreDefault(e);
    this.hideOverlayVideo(e);
    Middleware.resetUserPassword(this.state.email);
    this.setState({isBusy: true});
  };

  messageBoxErrorClick = () => {
    this.setState({isMessageBoxVisible: false, isMessageBoxError: true});
  };

  handleOskSetEmail = (value) => {
    Analytics.sendDataEnteredEvent('osk-set-email');
    this.setStateField('email', value);
  };

  handleOskSetPassword = (value) => {
    Analytics.sendDataEnteredEvent('osk-set-password');
    this.setStateField('password', value);
  };

  handleOskSetFullName = (value) => {
    Analytics.sendDataEnteredEvent('osk-set-fullname');
    this.setStateField('fullName', value);
  };

  handleOskSetZip = (value) => {
    Analytics.sendDataEnteredEvent('osk-set-zip');
    this.setStateField('zip', value);
  };

  handleOskSetPhoneNumber = (value) => {
    Analytics.sendDataEnteredEvent('osk-set-phone');
    this.setStateField('phoneNumber', value);
  };

  handleOskSetSalesPersonFullName = (value) => {
    Analytics.sendDataEnteredEvent('osk-set-salesPerson-fullname');
    this.setStateField('salesPersonFullName', value);
  };

  handleOskSetSalesPersonEmail = (value) => {
    Analytics.sendDataEnteredEvent('osk-set-salesPerson-email');
    this.setStateField('salesPersonEmail', value);
  };

  handleCloseClick = (e) => {
    Analytics.sendClickEvent('customer-login-close');
    Misc.ignoreDefault(e);
    this.hideOverlayVideo(e);
    this.props.hide();
  };

  handleSalesPersonClick = (e) => {
    Analytics.sendClickEvent('customer-salesPerson');
    Misc.ignoreDefault(e);
    this.hideOverlayVideo(e);
    if (this.state.view === 'login') {
      this.setState({salesPersonDetailsLoginVisible: !this.state.salesPersonDetailsLoginVisible});
    } else {
      this.setState({salesPersonDetailsVisible: !this.state.salesPersonDetailsVisible});
    }
  };

  hideOverlayVideo = (e) => {
    this.props.hideOverlayVideo();
    this.handleInputFocus();
  };

  handleInputFocus = () => {
    Config.isAndroid() && $('.app-container').addClass('app-container--android');
  };

  handleInputBlur = () => {
    $('.app-container').removeClass('app-container--android');
  };

  render() {
    let title = '';
    let content = null;
    let btn1Text = '';
    let btn2Text = '';
    let btn1Click = null;
    let btn2Click = null;
    let btn1Enabled = true;
    let btn2Enabled = true;
    let btn1Spinner = null;
    let btn2Spinner = null;

    const description = 'To instantly unlock Stone Pricing, Please enter your contact details.';

    switch (this.state.view) {
      case 'login':
        title = 'Instantly Unlock Pricing';
        content = this.renderLoginContent();
        btn1Text = 'Sign Up';
        btn2Text = this.state.isBusy ? 'Logging...' : 'Login';
        btn1Click = this.handleUserSignUpAttemptClick;
        btn2Click = this.handleUserLoginClick;
        btn1Enabled = !this.state.isBusy;
        btn2Enabled = !this.state.isBusy;
        btn2Spinner = this.state.isBusy ? this.renderButtonSpinner() : null;
        break;
      case 'register':
        title = 'Instantly Unlock Pricing';
        content = this.renderRegisterContent();
        btn1Text = 'Login';
        btn2Text = this.state.isBusy ? 'Registering...' : 'Continue';
        btn1Click = this.handleUserBackRegisterClick;
        btn2Click = this.handleUserRegisterClick;
        btn1Enabled = !this.state.isBusy;
        btn2Enabled = !this.state.isBusy;
        btn2Spinner = this.state.isBusy ? this.renderButtonSpinner() : null;
        break;
      case 'reset-password':
        title = 'Reset your password by entering in your current email address';
        content = this.renderResetPasswordContent();
        btn1Text = 'Back';
        btn2Text = this.state.isBusy ? 'Resetting...' : 'Reset';
        btn1Enabled = !this.state.isBusy;
        btn2Enabled = !this.state.isBusy;
        btn1Click = this.handleUserBackRegisterClick;
        btn2Click = this.handlePasswordResetButtonClick;
        btn2Spinner = this.state.isBusy ? this.renderButtonSpinner() : null;
        break;
      default:
        throw "The specified view is not supported. View: " + this.state.view;
    }

    let infoPopupStyle = {};
    if (this.state.view === 'login' || this.state.view === 'reset-password') {
      infoPopupStyle.height = this.state.salesPersonDetailsLoginVisible ? "475px" : "375px";
    }

    const classes = "customer-popup-overlay" + (this.props.visible ? " visible" : "");

    return (
      <div className={classes}>
        {this.state.isMessageBoxVisible
          ? <MessageBox error={this.state.isMessageBoxError}
                        message={this.state.errorMessage} click={this.messageBoxErrorClick}/>
          : null}
        <div className={"customer-info-popup" +
        (((this.state.view === 'register') && this.state.salesPersonDetailsVisible) ? " customer-info-popup--big" : "")}
             style={infoPopupStyle} id="ui-customer-info-popup">
          <div className="customer-info-popup__lock">
            <span className="customer-info-popup__lock-border"/>
            <span className="customer-info-popup__lock-circle">
              <span className="customer-info-popup__lock-circle-inner rotating"/>
            </span>
          </div>
          <div className="customer-popup-close-button" onClick={this.handleCloseClick} id="ui-button-close"/>
          <span><br/></span>
          <p className="customer-info-popup__title">{title}</p>
          {(this.state.view === 'register' || this.state.view === 'login') ?
            (<p className="customer-info-popup__description">{description}</p>) : null}
          {content}

          <div className="customer-info-buttons-wrapper customer-login-button-setting" onClick={btn1Click}>
            <div className="customer-info-buttons" id="ui-button1">
              {btn1Spinner}
              {btn1Text}
            </div>
          </div>
          <div className="customer-info-buttons-wrapper customer-continue-button-setting" onClick={btn2Click}>
            <div className="customer-info-buttons" id="ui-button2">
              {btn2Spinner}
              {btn2Text}
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderButtonSpinner = () => {
    return (<div className="button-spinner"/>);
  }

  renderResetPasswordContent = () => {
    return (<div className="customer-pw-reset-wrapper">
      <input value={this.state.email} className="customer-info-inputs-center" placeholder="Current Email"
             onFocus={this.handleInputFocus} onBlur={this.handleInputBlur}
             onChange={this.setStateField.bind(this, 'email')} id={this.state.emailId}/>
      <OnScreenKeyboard inputId={this.state.emailId} setValue={this.handleOskSetEmail} type="email"/>
    </div>);
  }

  renderLoginContent = () => {
    const salesPersonStyle = {
      display: !this.state.salesPersonDetailsLoginVisible ? 'none' : 'block'
    };

    return (
      <div className="customer-login-wrapper">
        <div className="customer-popup-sales-person-button" onClick={this.handleSalesPersonClick}
             id="ui-button-sales-person"/>
        <input value={this.state.email} className="customer-info-inputs-center" placeholder="Email"
               onFocus={this.handleInputFocus} onBlur={this.handleInputBlur}
               onChange={this.setStateField.bind(this, 'email')} id={this.state.emailId}
               key={this.state.emailId}/>
        <OnScreenKeyboard inputId={this.state.emailId} setValue={this.handleOskSetEmail} top="190px"
                          left="200px"
                          type="email"/>

        <input type="password" value={this.state.password} className="customer-info-inputs-center"
               placeholder="Password" onFocus={this.hideOverlayVideo} onBlur={this.handleInputBlur}
               onChange={this.setStateField.bind(this, 'password')} id={this.state.passwordId}
               key={this.state.passwordId}/>
        <OnScreenKeyboard inputId={this.state.passwordId} password={true} setValue={this.handleOskSetPassword}
                          top="240px" left="200px"/>

        {Config.kioskStandAlone ? null :
          <div className="customer-login-password-button" onClick={this.handleForgotPasswordClick}
               id="ui-forgot-password">
            Forgot Password?
          </div>
        }

        {this.state.salesPersonDetailsLoginVisible ? (
          <div>
            <input type="text" value={this.state.salesPersonFullName}
                   className="customer-info-inputs-center" onBlur={this.handleInputBlur}
                   placeholder="Sales Person" onFocus={this.hideOverlayVideo}
                   onChange={this.setStateField.bind(this, 'salesPersonFullName')}
                   id={this.state.salesPersonFullNameId}
                   style={salesPersonStyle} key={this.state.salesPersonFullNameId}/>
            <OnScreenKeyboard inputId={this.state.salesPersonFullNameId}
                              setValue={this.handleOskSetSalesPersonFullName}
                              top="330px" left="200px"
                              style={salesPersonStyle}/>
            <input type="text" value={this.state.salesPersonEmail} className="customer-info-inputs-center"
                   placeholder="Send to Additional Emails(s)" onFocus={this.hideOverlayVideo}
                   onChange={this.setStateField.bind(this, 'salesPersonEmail')} onBlur={this.handleInputBlur}
                   id={this.state.salesPersonEmailId}
                   style={salesPersonStyle} key={this.state.salesPersonEmailId}/>
            <OnScreenKeyboard inputId={this.state.salesPersonEmailId}
                              setValue={this.handleOskSetSalesPersonEmail}
                              top="380px" left="200px"
                              style={salesPersonStyle} type="email"/>
          </div>
        ) : null}
      </div>
    );
  };

  renderRegisterContent = () => {
    return (
      <div className="customer-info-wrapper">
        <div className="customer-popup-sales-person-button" onClick={this.handleSalesPersonClick}
             id="ui-button-sales-person"/>
        <input value={this.state.fullName} className="customer-info-inputs customer-info-inputs-left"
               placeholder="Full Name" required="required" onFocus={this.hideOverlayVideo} onBlur={this.handleInputBlur}
               onChange={this.setStateField.bind(this, 'fullName')} id={this.state.fullNameId}
               maxLength={50}
               key={this.state.fullNameId}/>
        <OnScreenKeyboard inputId={this.state.fullNameId} setValue={this.handleOskSetFullName} top="200px"
                          left="30px"/>

        <input value={this.state.email} className="customer-info-inputs customer-info-inputs-right"
               placeholder="Email" onBlur={this.handleInputBlur}
               onChange={this.setStateField.bind(this, 'email')} required="required" id={this.state.regEmailId}
               onFocus={this.hideOverlayVideo} maxLength={50}
               key={this.state.regEmailId}/>
        <OnScreenKeyboard inputId={this.state.regEmailId} setValue={this.handleOskSetEmail} top="200px"
                          left="450px"
                          type="email"/>

        {Config.kioskStandAlone ? 
          <input value={this.state.phoneNumber} className="customer-info-inputs customer-info-inputs-left"
            placeholder="Phone Number" required="required" onFocus={this.hideOverlayVideo}
            onChange={this.setStateField.bind(this, 'phoneNumber')} id={this.state.phoneNumberId}
            key={this.state.phoneNumberId} onBlur={this.handleInputBlur} maxLength={16}
          />
        :
        <IntlTelInput  css={['intl-tel-input', 'customer-info-inputs customer-info-inputs-left']}
              utilsScript={'/content/views/quickquote-v3/libphonenumber.js'} 
              value={this.state.phoneNumber}
              onSelectFlag={this.handleChangeFlag}
              placeholder="Phone Number" required="required" onFocus={this.hideOverlayVideo}
              onPhoneNumberChange={this.handleChangeNumber} id={this.state.phoneNumberId}
              defaultCountry={ 'auto' }
              key={this.state.phoneNumberId} onBlur={this.handleInputBlur} maxLength={16} />
        }
        <OnScreenKeyboard inputId={this.state.phoneNumberId} setValue={this.handleOskSetPhoneNumber} top="250px"
                          left="30px" type="numeric"/>

        <input value={this.state.zip} className="customer-info-inputs customer-info-inputs-right"
               placeholder="Postal Code" onFocus={this.hideOverlayVideo} onBlur={this.handleInputBlur}
               onChange={this.setStateField.bind(this, 'zip')} required="required" id={this.state.zipId}
               key={this.state.zipId} maxLength={10}/>
        <OnScreenKeyboard inputId={this.state.zipId} type="numeric" setValue={this.handleOskSetZip} top="250px"
                          left="450px"/>

        {this.state.salesPersonDetailsVisible ? (
          <div>
            <input value={this.state.salesPersonFullName}
                   className="customer-info-inputs customer-info-inputs-left" onBlur={this.handleInputBlur}
                   placeholder="Sales Person Name" onFocus={this.hideOverlayVideo}
                   onChange={this.setStateField.bind(this, 'salesPersonFullName')}
                   id={this.state.salesPersonFullNameId}
                   key={this.state.salesPersonFullNameId}/>
            <OnScreenKeyboard inputId={this.state.salesPersonFullNameId}
                              setValue={this.handleOskSetSalesPersonFullName}
                              top="300px" left="30px"/>

            <input value={this.state.salesPersonEmail}
                   className="customer-info-inputs customer-info-inputs-right" onBlur={this.handleInputBlur}
                   placeholder="Send to Additional Email(s)" onFocus={this.hideOverlayVideo}
                   onChange={this.setStateField.bind(this, 'salesPersonEmail')}
                   id={this.state.salesPersonEmailId}
                   key={this.state.salesPersonEmailId}/>
            <OnScreenKeyboard inputId={this.state.salesPersonEmailId}
                              setValue={this.handleOskSetSalesPersonEmail}
                              top="300px" left="450px" type="email"/>
          </div>) : null}
      </div>
    );
  }
};




// WEBPACK FOOTER //
// ./src/components/stones/customerView.js